import {Action} from "redux";
import {IClientProjectDetailActionCreator} from "../action/client_project_action";
import {
    GetProjectDetailByClientRequest,
    CreateProjectDetailByClientRequest,
    UpdateProjectDetailByClientRequest,
    DraftProjectDetailByClientRequest,
    OpenProjectDetailByClientRequest,
    CloseProjectDetailByClientRequest,
} from "../request/project_request";


interface IClientProjectDetailDispatcher {
    getProject(item: GetProjectDetailByClientRequest): void;

    createProject(item: CreateProjectDetailByClientRequest): void;

    updateProject(item: UpdateProjectDetailByClientRequest): void;

    draftProject(item: DraftProjectDetailByClientRequest): void;

    openProject(item: OpenProjectDetailByClientRequest): void;

    closeProject(item: CloseProjectDetailByClientRequest): void;
}

class Dispatcher implements IClientProjectDetailDispatcher {

    constructor(private dispatch: (action: Action) => void,
                private actionCreator: IClientProjectDetailActionCreator) {

    }

    public getProject = (item: GetProjectDetailByClientRequest): void => {
        this.dispatch(this.actionCreator.requestGetProjectDetailAction(item));
    };

    public createProject = (item: CreateProjectDetailByClientRequest): void => {
        this.dispatch(this.actionCreator.requestCreateProjectDetailAction(item))
    };

    public updateProject = (item: UpdateProjectDetailByClientRequest): void => {
        this.dispatch(this.actionCreator.requestUpdateProjectDetailAction(item))
    };

    public draftProject = (item: DraftProjectDetailByClientRequest): void => {
        this.dispatch(this.actionCreator.requestDraftProjectDetailAction(item));
    };

    public openProject = (item: OpenProjectDetailByClientRequest): void => {
        this.dispatch(this.actionCreator.requestOpenProjectDetailAction(item));
    };

    public closeProject = (item: CloseProjectDetailByClientRequest): void => {
        this.dispatch(this.actionCreator.requestCloseProjectDetailAction(item));
    };

}

const createClientProjectDetailDispatcher = (dispatch: (action: Action) => void, actionCreator: IClientProjectDetailActionCreator): IClientProjectDetailDispatcher => {
    return new Dispatcher(dispatch, actionCreator);
};

export {IClientProjectDetailDispatcher, createClientProjectDetailDispatcher};



// WEBPACK FOOTER //
// ./src/presentation/dispatcher/client_project_dispatcher.ts